<script>
    import SgiGameClient from '../sgi-game-client/index';
    import {$eBus} from '@/event-bus'
    import GameClientEvent from '@/enum/GameClientEvent'

    export default {
        name: 'game-client',
        extends: SgiGameClient,
    }
</script>